import React from 'react';
import Linker from '../linker/Linker';
import * as path from '../../../route/PathConfig';
import './Footer.css';

const Footer = () => {
  const pdfPath = "/files/버즈워드 이용 매뉴얼.pdf";

  return (
    <div id="footer_group">
      <div id="product_bg">
        <div id="footer_product">
          <ul className="product_nav">
            <li>
              <Linker path={path.STIPULATIONS}>
                약관 및 정책 게시글
              </Linker>
            </li>
            <li>
              <Linker path={path.MANAGEMENTPOLICY}>
                수집 및 관리정책
              </Linker>
            </li>
            <li>
              <Linker path={pdfPath} download={true} target="_blank">
                이용가이드
              </Linker>
            </li>
            <li>
              <Linker path={path.PRIVACY}>
              <a style={{color: '#6E37FA'}}><strong>개인정보 처리방침</strong></a>
              </Linker>
            </li>
          </ul>
        </div>
      </div>
      <div id="footer">
        <div class="footer_address">(04505) 서울시 중구 서소문로 50 센트럴플레이스 15층</div>
        <div class="footer_copyright">Copyright © Nielsen Media Korea Co., Ltd. All right Reserved </div> 
      </div>
    </div>
  )
}

export default Footer;